import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Popper-positioned tooltip arrow. The element is handed to Popper's `arrow`
 * modifier so it stays centred on the anchor even when `preventOverflow` shifts the
 * body; the `[data-popper-placement] > &` selectors place it on the correct edge.
 * Adapted from {@link PopoverArrow}.
 */ export const TooltipArrow = /*#__PURE__*/ forwardRef(function TooltipArrow({ size, color }, ref) {
    const edge = `-${size}px`;
    const tip = size / 2;
    const containerSize = {
        vertical: {
            width: size * 2,
            height: size
        },
        horizontal: {
            width: size,
            height: size * 2
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        "data-testid": "tooltip-arrow",
        css: {
            overflow: 'hidden',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                width: size * 2,
                height: size * 2,
                // Subtle rounding on the tip, matching the previous arrow.
                borderRadius: 2,
                background: color,
                transform: 'rotate(45deg)'
            },
            '[data-popper-placement^="top"] &': {
                bottom: edge,
                ...containerSize.vertical,
                '&::before': {
                    bottom: tip
                }
            },
            '[data-popper-placement^="right"] &': {
                left: edge,
                ...containerSize.horizontal,
                '&::before': {
                    left: tip
                }
            },
            '[data-popper-placement^="bottom"] &': {
                top: edge,
                ...containerSize.vertical,
                '&::before': {
                    top: tip
                }
            },
            '[data-popper-placement^="left"] &': {
                right: edge,
                ...containerSize.horizontal,
                '&::before': {
                    right: tip
                }
            }
        }
    });
});

//# sourceMappingURL=tooltipArrow.js.map